import React, { useEffect, useState } from "react";
import api from "../api/axios";
import VoucherDetails from "../components/modal/VoucherDetails";
import TransactionForm from "../components/forms/TransactionForm";

function StoredMonthlyJournalList() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));


    const token = localStorage.getItem("accessToken");
    const branch_id = sessionStorage.getItem("selectedContext")
        ? JSON.parse(sessionStorage.getItem("selectedContext")).branch
        : 0;

    // ===== Fetch Data =====
    const fetchData = async (selectedMonth) => {
        setLoading(true);
        try {
            const res = await api.get(
                `/stored-monthly-journals?branch_id=${branch_id}&month=${selectedMonth}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.status === 1) {
                setData(res.data.response);
            } else {
                setData([]);
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(month);
    }, [month]);

    // ===== Month Dropdown Options (last 12 months) =====
    const getMonthOptions = () => {
        const months = [];
        const now = new Date();

        for (let i = 0; i < 12; i++) {
            const d = new Date(now.getFullYear(), now.getMonth() - i, 1);

            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, "0");

            const value = `${year}-${month}`;
            const label = d.toLocaleString("en-US", {
                month: "long",
                year: "numeric",
            });

            months.push({ value, label });
        }

        return months;
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        const d = new Date(dateStr);
        return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
            .toString()
            .padStart(2, "0")}-${d.getFullYear()}`;
    };

    const getMonthRange = (month) => {
        const [year, m] = month.split("-");

        const startDate = `${year}-${m}-01`;

        // last day of month
        const end = new Date(year, m, 0);
        const endDate = `${year}-${m}-${end.getDate().toString().padStart(2, "0")}`;

        return { startDate, endDate };
    };

    return (
        <>
            {/* Header */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-flex justify-content-between align-items-center">
                        <h4 className="mb-sm-0">Monthly Journal List</h4>

                        {/* Month Dropdown */}
                        <select
                            className="form-select w-auto"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                        >
                            {getMonthOptions().map((m) => (
                                <option key={m.value} value={m.value}>
                                    {m.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Card */}
            <div className="card">


                <div className="card-body">
                    {loading ? (
                        <p>Loading...</p>
                    ) : (
                        <div className="table-responsive ledger-scroll">
                            <table className="table table-bordered table-sm ledger-table">
                                <thead className="table-light sticky-top">
                                    <tr>
                                        <th>Code</th>
                                        <th>Office</th>
                                        <th>Company</th>
                                        <th>Start</th>
                                        <th>End</th>
                                        <th>Amount</th>
                                        <th>Voucher</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.length > 0 ? (
                                        data.map((item) => {
                                            console.log(item);
                                            const client = item.client_onboard;
                                            return (
                                                <tr key={item.id}>
                                                    <td>{item.tenant_ledger?.ledger_code || "-"}</td>
                                                    <td>{client?.office?.office_no || "-"}</td>
                                                    <td> {client?.company_name || "-"}</td>
                                                    <td>{formatDate(client?.contarct_start_date)}</td>
                                                    <td>{formatDate(client?.contarct_end_date)}</td>
                                                    <td>{item.amount}</td>
                                                    <td>
                                                        <span
                                                            className="voucher-link"
                                                            onClick={() => {
                                                                const { startDate, endDate } = getMonthRange(month);

                                                                window.openPanel(
                                                                    "Journal Entry Details",
                                                                    <VoucherDetails
                                                                        voucherId={item?.voucher_id}
                                                                        startDate={startDate}
                                                                        endDate={endDate}
                                                                    />
                                                                );
                                                            }}
                                                        >
                                                            {item?.voucher?.series_no || "-"}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="text-center">
                                                No records found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default StoredMonthlyJournalList;